import { useQuery } from '@tanstack/react-query';
import { ActivityPointApi } from 'api/ApiHelper';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';

export const useGetActivityPointRankExcludedQuery = (enabled = false) =>
  useQuery({
    queryKey: activityPointQueryKey.activityPointRankExcluded(),
    queryFn: () => ActivityPointApi.getExcluded(),
    enabled,
  });
